// src/App.tsx
import React, { useEffect, useState } from 'react';
import styles from './App.module.css';
import ResourceDisplay from './components/ResourceDisplay';

interface ResourceEntry {
  folder: string;
  textFile: string;
  imageFile: string;
}

function App() {
  const [resources, setResources] = useState<ResourceEntry[]>([]);

  useEffect(() => {
    fetch('/resources/resources.json')
      .then((res) => res.json())
      .then((data) => setResources(data))
      .catch((err) => console.error('Failed to load resources:', err));
  }, []);

  return (
    <div className={styles.App}>
      <div className={styles.AppHeader}>
        {resources.map((entry) => (
          <ResourceDisplay key={entry.folder} folderName={entry.folder} />
        ))}
      </div>
      <footer className={styles.footer}>
        ©wokingcarboot {new Date().getFullYear()}
      </footer>
    </div>
  );
}

export default App;
